import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className='mt-5 pt-4 pb-3' style={{ backgroundColor: '#FFF0F5', borderTop: '1px solid #FFB6C1' }}>
        <Container>
          <Row className='mb-3'>
            <Col xs={12} md={4} className='text-center text-md-start mb-2 mb-md-0'>
              <strong style={{ color: '#FF69B4' }}>TaleTots</strong>
              <div><small className='text-muted'>{t('footer.tagline')}</small></div>
            </Col>
            <Col xs={12} md={5} className='text-center mb-2 mb-md-0'>
              <Link to='/faq' className='text-muted me-3' style={{ textDecoration: 'none' }}>{t('nav.faq')}</Link>
              <Link to='/contact' className='text-muted me-3' style={{ textDecoration: 'none' }}>{t('nav.contact')}</Link>
              <Link to='/about' className='text-muted me-3' style={{ textDecoration: 'none' }}>{t('nav.aboutUs')}</Link>
              <Link to='/privacy' className='text-muted' style={{ textDecoration: 'none' }}>{t('nav.privacy', 'Privacy Policy')}</Link>
            </Col>
            <Col xs={12} md={3} className='text-center text-md-end'>
              <a href='mailto:contact@taletots.net' className='text-muted small' style={{ textDecoration: 'none' }}>
                contact@taletots.net
              </a>
            </Col>
          </Row>
          <Row>
            <Col className='text-center'>
              <small className='text-muted'>{t('footer.copyright', { year: new Date().getFullYear() })}</small>
            </Col>
          </Row>
        </Container>
    </footer>
  )
}

export default Footer
